import { useQuery } from '@tanstack/react-query';
import { moderationQueries } from '../api/moderation-queries';
import type { ModerationEntityType } from '../lib/moderation-config';
import type { ModerationListFilter } from './list-params';
import type { ChangeRequest } from './schema';

/** Thin hooks wrapping the moderation query options (CLAUDE.md entity contract). */
export function useModerationList(
  entityType: ModerationEntityType,
  filter: ModerationListFilter,
) {
  return useQuery(moderationQueries.list(entityType, filter));
}

/** The entity's review card (`{prod, manual, sync}`); idle without an id. */
export function useModerationCard(entityType: ModerationEntityType, entityId: string) {
  return useQuery(moderationQueries.card(entityType, entityId));
}

/** The freshest copy of one request, seeded from its queue row. */
export function useModerationRequest(seed: ChangeRequest) {
  return useQuery(moderationQueries.request(seed));
}
